import type { StepConfigParams } from '@flows/configs/types'
import type { AnyStepConfiguration } from '@flows/core/types/stepTypes'

const liability_insurance_choice = (params: StepConfigParams) =>
  ({
    stepContent: [
      {
        type: 'title',
        text: {
          type: 'translatableText',
          translationKey: 'sharedFlows_liabilityNxt:steps.dynamic.liability.choice.title',
        },
      },
      {
        type: 'subtitle',
        text: {
          type: 'translatableText',
          translationKey: 'sharedFlows_liabilityNxt:steps.dynamic.liability.choice.subtitle',
        },
      },
      {
        type: 'yesNo',
        name: 'product_keys.liability_v1_getsafe_de',
      },
    ],
    onPrepare: {
      type: 'simpleHook',
      callback: () => {
        return {
          formValues: {
            'product_keys.liability_v1_getsafe_de': '',
          },
        }
      },
    },
    subFlow: params.subFlow,
  }) as const satisfies AnyStepConfiguration

export default liability_insurance_choice
